import {
  SAVE_ADJUSTMENT,
  SAVE_ADJUSTMENT_SUCCESS,
  SAVE_ADJUSTMENT_FAILURE,
  REMOVE_ADJUSTMENT,
  REMOVE_ADJUSTMENT_SUCCESS,
  REMOVE_ADJUSTMENT_FAILURE,
  FETCH_ADJUSTMENT_ATTACHMENTS,
  FETCH_ADJUSTMENT_ATTACHMENTS_SUCCESS,
  FETCH_ADJUSTMENT_ATTACHMENTS_FAILURE,
  FETCH_INITIAL_DATA_FOR_ADJUSTMENT_MODAL,
  FETCH_INITIAL_DATA_FOR_ADJUSTMENT_MODAL_SUCCESS,
  FETCH_INITIAL_DATA_FOR_ADJUSTMENT_MODAL_FAILURE,
} from './types';
import {
  FETCH_PROVISION_DATA_SUCCESS,
  FETCH_ACCOUNTS_STARTED,
  FETCH_ACCOUNTS_SUCCESS,
  FETCH_ACCOUNTS_FAILURE,
} from '../../../shared/store/types';
import {
  CALCULATE_PROVISION_SUCCESS,
} from '../../store/types';
import initialState from './initialState';

function adjustmentsReducer(state = initialState, action) {
  switch (action.type) {
    case SAVE_ADJUSTMENT:
      return {
        ...state,
        savingAdjustment: true,
      };
    case SAVE_ADJUSTMENT_SUCCESS:
      return {
        ...state,
        savingAdjustment: false,
      };
    case SAVE_ADJUSTMENT_FAILURE:
      return {
        ...state,
        savingAdjustment: false,
      };
    case REMOVE_ADJUSTMENT:
      return {
        ...state,
        removingAdjustment: true,
      };
    case REMOVE_ADJUSTMENT_SUCCESS:
    case REMOVE_ADJUSTMENT_FAILURE:
      return {
        ...state,
        removingAdjustment: false,
      };
    case FETCH_PROVISION_DATA_SUCCESS:
    case CALCULATE_PROVISION_SUCCESS:
      return {
        ...state,
        adjustmentsCollection: action.provisionData.adjustments,
        bookToTaxDifferencesCollection: action.provisionData.bookToTaxDifferencesCollection,
        NOLRollforwardsCollection: action.provisionData.NOLRollforwardsCollection,
      };
    case FETCH_ACCOUNTS_STARTED:
      return {
        ...state,
        accountsFetching: true,
        accounts: [],
      };
    case FETCH_ACCOUNTS_SUCCESS:
      return {
        ...state,
        accountsFetching: false,
        accounts: action.accounts,
      };
    case FETCH_ACCOUNTS_FAILURE:
      return {
        ...state,
        accountsFetching: false,
        accounts: [],
      };
    case FETCH_ADJUSTMENT_ATTACHMENTS:
      return {
        ...state,
        adjustmentAttachments: [],
        fetchingAttachments: true,
      };
    case FETCH_ADJUSTMENT_ATTACHMENTS_SUCCESS:
      return {
        ...state,
        adjustmentAttachments: action.adjustmentAttachments,
        fetchingAttachments: false,
      };
    case FETCH_ADJUSTMENT_ATTACHMENTS_FAILURE:
      return {
        ...state,
        adjustmentAttachments: [],
        fetchingAttachments: false,
      };
    case FETCH_INITIAL_DATA_FOR_ADJUSTMENT_MODAL:
      return {
        ...state,
        fetchingInitialDataForAdjustmentModal: true,
      };
    case FETCH_INITIAL_DATA_FOR_ADJUSTMENT_MODAL_SUCCESS:
    case FETCH_INITIAL_DATA_FOR_ADJUSTMENT_MODAL_FAILURE:
      return {
        ...state,
        fetchingInitialDataForAdjustmentModal: false,
      };
    default:
      return state;
  }
}

export default adjustmentsReducer;
